import { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BusinessSection from './components/BusinessSection';
import FacilitySection from './components/FacilitySection';
import CompanySection from './components/CompanySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    document.title = '東京都江東区の専門工事業者｜電気・管・土木・内装工事 株式会社テクノワークス';
  }, []);

  return (
    <div className="min-h-screen w-full" style={{ fontFamily: '\'Noto Sans JP\', sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <BusinessSection />
        <FacilitySection />
        <CompanySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
